export default {
	'展位信息确认':'一、展位信息确认',
	'展位基本信息':'二、展位基本信息',
	'承建商信息':'三、承建商信息',
	'审图资料上传':'四、审图资料上传',
	'地毯颜色选择':'地毯颜色选择',
	'车证申请':'车证申请',
	'施工证申请':'施工证申请',
	'报图结束':'报图结束',
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/drawings/drawings.js